<template>
  <div id="container">
    <div class="content">
      <div
        class="item-box-content"
        style="padding:14px 20px;">
        <div class="title-font-style">
          <span>银行表单表头映射</span>
        </div>
      </div>

      <!-------------- 列表 -------------->
      <div class="item-box-content">
        <el-table
          border
          ref="tableRef"
          :data="list"
          height="600"
          stripe
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            prop="bankName"
            label="银行名称">
          </el-table-column>
          <el-table-column
            prop="updateDate"
            label="更新时间">
            <template slot-scope="scope">{{formatData(scope.row.updateDate)}}</template>
          </el-table-column>
          <el-table-column
            prop
            label="操作"
            width="120px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                @click="onAddOrEditUnit(1,scope.row)">设置关联
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 侧边栏---添加/修改模板 -->
    <bank-header-temple ref="bankHeaderTempleRefs"></bank-header-temple>
  </div>
</template>

<script>
  import { BanKHeader } from '@/api/system/rightsManagement.js'

  import { expressionList } from '@/components/utils/data'
  import bankHeaderTemple from '../sliderBar/bankHeaderTemple'

  import { formatData } from '@/util/filterCommon'

  export default {
    components: {
      'bank-header-temple': bankHeaderTemple
    },
    data () {
      return {
        queryParams: {},
        params: {},
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [], // 列表数据
        pageSize: 30, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true
      }
    },
    mounted () {
      this.getInit()
    },
    methods: {
      formatData,
      getInit () {
        BanKHeader().then(res => {
          if (res.data.code === 200) {
            this.list = res.data.obj
            // debugger
          }
        })
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 修改模板
      onAddOrEditUnit (type, row) {
        this.$refs.bankHeaderTempleRefs.onInitial(type, row)
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        this.getList()
      }
    }
  }
</script>

<style
  style="scss"
  scoped>
  .search-style {
    padding: 10px 20px 10px 30px;
  }
</style>
